module.exports = __webpack_public_path__ + "static/media/logo-brand-competition.d1219250.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-brand-competition.svg
// module id = 478
// module chunks = 0